'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function removePrefixLoading() {
  var $prefixLoading = document.getElementById('prefix-loading');
  if ($prefixLoading) {
    $prefixLoading.parentNode.removeChild($prefixLoading);
  }
}

exports.default = removePrefixLoading;